import { useEffect, useState } from "react";
import { Button } from "../ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "../ui/card";
import { Label } from "../ui/label";
import { ScrollArea } from "../ui/scroll-area";
import { Textarea } from "../ui/textarea";
import { ChevronLeft, ChevronDown } from "lucide-react";

import {
    DropdownMenu,
    DropdownMenuTrigger,
    DropdownMenuContent,
    DropdownMenuLabel,
    DropdownMenuItem,
    DropdownMenuSeparator
} from "../ui/dropdown-menu";

interface SaveRuleStepProps {
    onBack: () => void;
    finalRule: string | null;
    onSave: (data: any) => void;
    isSaving: boolean;
}

const ruleTypeOptions = [
    { value: "0", label: "Eligibility Rules" },
    { value: "1", label: "Pricing Rules" },
    { value: "2", label: "Credit Rating Rules" },
    { value: "4", label: "Workflow Entry Conditions" },
    { value: "5", label: "Compliance Rules" },
    { value: "6", label: "Form Rules" },
];

export const SaveRuleStep = ({ finalRule, onBack, onSave, isSaving }: SaveRuleStepProps) => {
    const [ruleName, setRuleName] = useState("");
    const [ruleType, setRuleType] = useState("");
console.log("iuihubhub", ruleType)
    useEffect(() => {
        const editRuleData = localStorage.getItem("selectedRuleAI");
        if (editRuleData) {
            const ruleAIData = JSON.parse(editRuleData ?? "")
            setRuleName(ruleAIData?.Name ?? "")
            setRuleType(JSON.stringify(ruleAIData?.Type))
        }
    }, [])

    const handleSubmit = (e: any) => {
        e.preventDefault();
        let ruleObj
        let payload

        const editRuleData = localStorage.getItem("selectedRuleAI");
        if (editRuleData) {
            ruleObj = JSON.parse(editRuleData ?? "")
        }
        const aiexp = sessionStorage.getItem("generatedRule");

        ruleObj?.ID ?
            payload = {
                id: ruleObj?.ID,
                name: ruleName,
                type: Number(ruleType),
                body: finalRule,
                ai_rule_expression: aiexp
            } :
            payload = {
                id: ruleObj?.ID,
                name: ruleName,
                type: Number(ruleType),
                body: finalRule,
                ai_rule_expression: aiexp
            };

        onSave(payload);
    };

    return (
        <div className="space-y-6">
            <Card>
                <CardHeader>
                    <CardTitle>Save Final Rule</CardTitle>
                    <CardDescription>Provide details for your new rule</CardDescription>
                </CardHeader>

                <CardContent>
                    <form onSubmit={handleSubmit} className="space-y-5">

                        <div className="flex gap-4">
                            <div className="flex-1">
                                <Label htmlFor="ruleName">Rule Name</Label>
                                <input
                                    id="ruleName"
                                    type="text"
                                    placeholder="e.g., Eligibility Rule for Adults"
                                    value={ruleName}
                                    onChange={(e) => setRuleName(e.target.value)}
                                    className="flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm"
                                />
                            </div>

                            <div className="flex-1">
                                <Label>Rule Type</Label>

                                <DropdownMenu>
                                    <DropdownMenuTrigger asChild>
                                        <Button
                                            variant="outline"
                                            className="flex items-center justify-between w-full sm:w-full"
                                        >
                                            {ruleType
                                                ? ruleTypeOptions.find(x => x.value === ruleType)?.label
                                                : "Select a rule type"}
                                            <ChevronDown className="h-4 w-4 ml-2 opacity-70" />
                                        </Button>
                                    </DropdownMenuTrigger>

                                    <DropdownMenuContent className="w-full sm:w-1/2">
                                        <DropdownMenuLabel>Select Rule Type</DropdownMenuLabel>
                                        <DropdownMenuSeparator />

                                        {ruleTypeOptions.map((opt) => (
                                            <DropdownMenuItem
                                                key={opt.value}
                                                onClick={() => setRuleType(opt.value)}
                                                className="cursor-pointer w-[480px]"
                                            >
                                                {opt.label}
                                            </DropdownMenuItem>
                                        ))}
                                    </DropdownMenuContent>
                                </DropdownMenu>
                            </div>
                        </div>

                        <div className="space-y-2">
                            <Label>Generated Final Rule</Label>
                            <ScrollArea className="h-[220px] w-full rounded-md border bg-slate-50 p-4">
                                <code className="text-sm font-mono whitespace-pre-wrap">
                                    {finalRule}
                                </code>
                            </ScrollArea>
                        </div>

                        <div className="flex items-center w-full">
                            <Button
                                type="button"
                                variant="outline"
                                onClick={onBack}
                                className="gap-2"
                            >
                                <ChevronLeft className="h-4 w-4" />
                                Back
                            </Button>

                            <div className="flex-1 text-center">
                                <Button type="submit" disabled={isSaving}>
                                    {isSaving ? "Saving..." : "Save Rule"}
                                </Button>
                            </div>
                        </div>

                    </form>
                </CardContent>
            </Card>
        </div>
    );
};
